import { render } from "./acquiring-templates.vue?vue&type=template&id=29b6c608&scoped=true&ts=true"
import script from "./acquiring-templates.vue?vue&type=script&lang=ts"
export * from "./acquiring-templates.vue?vue&type=script&lang=ts"

import "./acquiring-templates.vue?vue&type=style&index=0&id=29b6c608&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b6c608"]])

export default __exports__